import { FormControl } from "@angular/forms";
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { Product } from "src/app/models/onboarding.model";
import { ShareAmountService } from "src/app/services/share-amount.service";
import { OnboardingService } from "src/app/services/onboarding.service";
import { DataShareService } from "src/app/services/data-share.service";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "app-product-card",
  templateUrl: "./product-card.component.html",
  styleUrls: ["./product-card.component.scss"],
})
export class ProductCardComponent implements OnInit,OnDestroy {
  private _product: Product;
  @Input() orderCount: number;
  @Input() slider: boolean;
  @Input() isOnBoarding:boolean;
  @Input()
  set product(value: Product) {
    this._product = value;
    this.setCurrentTier();
  }
 
  get product() {
    return this._product;
  }
  @Output() selectedTier: EventEmitter<number> = new EventEmitter();
  showProduct:boolean = false;
  selectTierId:number;
  isAddToYard:boolean = true;
  private _currentTier: number;
  set currentTier(number: number) {
    if (this._currentTier && number !=null) this.getPriceDiff([number]);
    this._currentTier = number;
    this.selectTier(number);
  }
  get currentTier() {
    return this._currentTier;
  }
  tierControl: FormControl = new FormControl();
  tierIndex: number;
  priceDiffResponse;
  features;
  isCurrentProduct:boolean=false;
  @Output() setNetyard: EventEmitter<any> = new EventEmitter();
  private destroy$ = new Subject<void>();

  constructor(
    private onboardingService: OnboardingService,
    private dataShareService: DataShareService,
    private shareAmountService: ShareAmountService
 
  ) {
    this.dataShareService.currentItem.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      if (res && res.product== this.product.name){
        this.isCurrentProduct=true
        this.currentTier = res.tierId;
      }
      else{
        this.isCurrentProduct=false
      }
    });
  }

  ngOnInit(): void {
    if(this.isOnBoarding){
      let index = this.product.tiers.findIndex((e) => e.name == 'Freemium');
      if(index !== -1){
        this.product.tiers.splice(index,1);
      }
    }
  }

  getPriceDiff(tiers: number[]) {
    this.onboardingService.PriceDiff(tiers).pipe(takeUntil(this.destroy$)).subscribe((e: any) => {
      if (e) this.priceDiffResponse = e;
    });
  }

  setCurrentTier() {
    this.tierIndex = this.product.tiers.findIndex((e) => e.isSelected);
    if (this.tierIndex != -1) {
      this.currentTier = this.product.tiers[this.tierIndex].tierId;
    }

    this.tierControl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((e) => {
      const index = this.product.tiers.findIndex((res:any) => res.tierId === e);
      this.product.tiers.forEach((e) => (e.isSelected = false));
      if (e && index != -1) {
        this.product.tiers[index].isSelected = true;
        this.product.isRemoved=false;
        this.setFeatureAccordingToOrders(index);     
      }
    });
  }

  addToYard() {
    this.isAddToYard = false,
    this.currentTier = this.product.tiers[0].tierId;
  }

  removeFromYard(product) {
    if(this.isOnBoarding){
      this.features = [];
      this.saveTierSelection();
      this.selectedTier.emit();
    } else {
      this.features = [];
      this.currentTier = null;
      this.selectedTier.emit(product);
    }
  }

  selectTier(tierId?) {
    this.selectTierId = tierId
    if (tierId != null) {
      const index = this.product.tiers.findIndex((e) => e.tierId === tierId);
      this.product.tiers.forEach((e) => (e.isSelected = false));
      if (tierId && index != -1) {
        this.product.tiers[index].isSelected = true;
        this.product.isRemoved=false;
        this.tierControl.setValue(tierId, { emitEvent: false });
        this.setFeatureAccordingToOrders(index);        
        this.shareAmountService.setAmount({amount:this.product.tiers[index].upto,product:this.product.name});
       
      } else {
        if (index !== -1) {
          this.product.tiers[index].isSelected = false;
        }
        this.tierControl.setValue(null, { emitEvent: false });
      }
      if(this.isAddToYard) this.selectedTier.emit(tierId);
    } else {
      this.product.tiers.forEach((e) => (e.isSelected = false));
      this.selectedTier.emit(tierId);
    }
    this.isAddToYard = false;
  }

  setFeatureAccordingToOrders(index) {
    this.product.tiers[index].features;
    this.features = this.product.tiers[index].features;
    this.product.features.forEach((e) => (e.isSelected = false));
    this.product.features.forEach((feature, i) => {
      if (i + 1 <= index + 1 && index + 1 <= feature.minTier) {
        feature.isSelected = true;
        return true;
      }
    });
  }

  setFeatureAccordingToOrder(index) {
    this.product.features.forEach((e) => (e.isSelected = false));
    this.product.features.forEach((feature, i) => {
      if (i + 1 <= index + 1 && index + 1 <= feature.minTier) {
        feature.isSelected = true;
        return true;
      }
    });
  }
  
  getTierName(tierId) {
    const index = this.product.tiers.findIndex(
      (tier) => tier.tierId === tierId
    );
    if (index != -1) {
      return this.product.tiers[index].name;
    }
  }

  columnVisible(name,value?){
    if(this.product.name == name){    
      this.product.visible = !this.product.visible;
      if (this.product?.productId == 1 && this.isOnBoarding && this.product.tiers?.length === 1) {
        this.currentTier = this.product.tiers[0]?.tierId;
      }
      if (value == 'edit') {
        this.showProduct = true
      } else {
        this.showProduct = false
      }
    }
  }

 add(){
  this.tierIndex = this.product.tiers.findIndex((e) => e.tierId == this.tierControl.value);
  if (this.tierIndex != -1) {
    this.currentTier = this.product.tiers[this.tierIndex].tierId;
  }
  this.product.visible = !this.product.visible;
  this.selectedTier.emit(this.selectTierId);  
 }

 cancel(){
  this.product.visible = !this.product.visible;
 }
 
 saveTierSelection(){
    let index =  this.onboardingService.tiers.findIndex((el)=> el == this.currentTier);
    if(index !== -1){
      this.onboardingService.tiers.splice(index,1)
    }  
    this.onboardingService
      .SaveTierSelection({ tiers: this.onboardingService.tiers}).pipe(takeUntil(this.destroy$))
      .subscribe((e) => {
        this.currentTier = null;
        this.tierIndex = this.product.tiers.findIndex((e) => e.tierId == this.currentTier);
        if (this.tierIndex != -1) {
          this.currentTier = this.product.tiers[this.tierIndex].tierId;
        }      
      });
 }

 ngOnDestroy() {
  this.destroy$.next();
  this.destroy$.unsubscribe();
 }
}
